import React, { useState, useRef, useEffect } from "react";
import "../../assets/Style.css";

export default function Responsive() {
    const previewRef = useRef(null);

    const deviceOptions = [
        {
            width: 600,
            height: 500,
            label: "Desktop Interface",
            frame: process.env.PUBLIC_URL + "/images/desktopscreen.png",
            preview: process.env.PUBLIC_URL + "/images/res1.png",
        },
        {
            width: 500,
            height: 500,
            label: "Laptop Interface",
            frame: process.env.PUBLIC_URL + "/images/laptopscreen.png",
            preview: process.env.PUBLIC_URL + "/images/res2.png",
        },
        {
            width: 450,
            height: 500,
            label: "Tablet Interface",
            frame: process.env.PUBLIC_URL + "/images/tablatescreen.png",
            preview: process.env.PUBLIC_URL + "/images/res3.png",
        },
        {
            width: 300,
            height: 500,
            label: "Mobile Interface",
            frame: process.env.PUBLIC_URL + "/images/mobilescreen.png",
            preview: process.env.PUBLIC_URL + "/images/res4.png",
            previewClass: "mobile-preview",
        }
    ];

    const [selectedDevice, setSelectedDevice] = useState(deviceOptions[0]);

    // 🔥 Preload all images once
    useEffect(() => {
        deviceOptions.forEach((device) => {
            const img = new Image();
            img.src = device.frame;
        });
    }, []);

    // 🔥 Auto Scroll Effect
    useEffect(() => {
        const scrolling = previewRef.current;
        let scrollAmount = 0;
        let animationFrame;

        const scrollContent = () => {
            if (scrolling) {
                scrollAmount += 0.5;

                if (scrollAmount >= scrolling.scrollHeight - scrolling.clientHeight) {
                    scrollAmount = 0;
                }

                scrolling.scrollTop = scrollAmount;
            }
            animationFrame = requestAnimationFrame(scrollContent);
        };

        scrollContent();

        return () => cancelAnimationFrame(animationFrame);
    }, [selectedDevice]);

    return (
        <section className="app-area">
            <div className="app-heading">
                <h2>One Website. Every Screen</h2>
                <p>
                    Your audience is everywhere—your website should be too. We build
                    beautifully responsive designs that feel just right on every device.
                </p>
            </div>

            <div className="app-container">
                {/* 🔥 Preview Section */}
                <div className="preview-wrapper">
                    <div
                        className="device-preview"
                        style={{
                            position: "relative",
                            width: selectedDevice.width,
                            height: selectedDevice.height,
                            maxWidth: "100%",
                            margin: "0 auto",
                        }}
                    >
                        {/* 🔥 Scrollable Screen */}
                        <div
                            ref={previewRef}
                            style={{
                                position: "absolute",
                                top: "0%",
                                height: "100%",
                                overflowY: "scroll",
                                borderRadius: "0px",
                                scrollbarWidth: "none",
                            }}
                        >
                            <img
                                src={selectedDevice.frame}
                                alt="Website Preview"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    display: "block",
                                }}
                            />
                        </div>
                    </div>

                    <p className="device-label">{selectedDevice.label}</p>
                </div>

                {/* 🔥 Device Buttons */}
                <div className="device-controls">
                    {deviceOptions.map((device, index) => (
                        <button
                            key={index}
                            className={`device-btn ${
                                selectedDevice.label === device.label ? "active" : ""
                            }`}
                            onClick={() => {
                                // 🔥 Load image first → then change (NO FLASH)
                                const img = new Image();
                                img.src = device.frame;

                                img.onload = () => {
                                    setSelectedDevice(device);
                                };
                            }}
                        >
                            <img
                                src={device.preview}
                                alt={device.label}
                                className={`preview-img ${device.previewClass || ""}`}
                            />
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
}